import { QueryKey } from "@tanstack/react-query";

export const ruleAsPublicQueryKeys = {
  all: () => ['ruleAsPublic'] as const,
  list: (filters: Readonly<{ [k: string]: any }>) => [...ruleAsPublicQueryKeys.all(), { filters }] as QueryKey,
  values: (clubId: number) => [...ruleAsPublicQueryKeys.all(), 'values', { clubId }] as QueryKey,
  rules: (params?: Record<string, number>) => [...ruleAsPublicQueryKeys.all(), 'rules', params] as QueryKey,
};
